import {DeleteData, GetAllData, setDefaultCustomNumber} from './CustomNumberSlice/CustomNumberSlice'
import moment from 'moment'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import CreateCutomNumber from './Modal/CreateCutomNumber'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {KTSVG} from '../../../../../_metronic/helpers'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import InsertNewData from '../../../../Components/InsertNewData'
import {getAllUserDetails, getIsDefaultRegion} from '../Overview/OverviewSlice/UserDetailsSlice'
import {CustomNumber} from '../../../../../services/cellcast.type'

type Props = {
  showModalNew: boolean,
  setShowModalNew: (visible: boolean) => void,
  onClickLearnMore: () => void;
}

const CustomNumberList: React.FC<Props> = ({
  showModalNew,
  setShowModalNew,
  onClickLearnMore,
  }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const CustomNumberList = useSelector((state: any) => state?.CustomNumber?.CustomNumberList)
  const userData: any = useSelector(getAllUserDetails)

  useEffect(() => {
    dispatch(GetAllData())
  }, [])
  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteData({
          customNumbersId: [deleteIds],
        })
      )

      setConfirm(false)
    }
  }, [confirm])

  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }
  const Customnumber = useMemo(
    () => <CreateCutomNumber show={showModalNew} handleClose={() => setShowModalNew(false)} />,
    [showModalNew]
  )
  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete custom number?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const isShareNumber = useCallback(
    (senderData: CustomNumber) => {
      if (senderData && senderData.allocatedUsers && Array.isArray(senderData.allocatedUsers)) {
        const userID = userData._id

        if (userID && senderData.allocatedUsers.includes(userID)) {
          return true
        }
      }
      return false
    },
    [userData]
  )

  const bgColor: any = {
    inactive: 'warning',
    active: 'success',
    DENIED: 'danger',
  }

  return (
    <>
      {Customnumber}
      {confirmation}
      <div className={`card`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <div>
              <span className='card-label fw-bolder fs-3 mb-1 small-title'>Custom number</span>
              <i
                onClick={() => onClickLearnMore()}
                className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
              />
            </div>
          </h3>
          {isDefaultRegion && AuthenticateUser('create-custom-number') && (
            <div
              className='card-toolbar'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title='Click to add a user'
            >
              <span
                data-testid='btnAddCustomNumber'
                className='btn btn-sm btn-primary'
                onClick={() => setShowModalNew(true)}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                Verify new number
              </span>
            </div>
          )}
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        {CustomNumberList?.data?.length > 0 ? (
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-150px'>NAME</th>
                    <th>NUMBER</th>
                    <th>REQUESTED</th>
                    <th>APPROVED</th>
                    <th>STATUS</th>

                    <th className='min-w-100px text-center'>Actions</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {CustomNumberList?.data?.map((val: any, i: number) => (
                    <tr key={i}>
                      <td>{val?.name}</td>
                      <td>{val?.number}</td>
                      <td>{moment(val?.createdAt).fromNow()}</td>
                      <td>
                        {val?.approvedAt !== undefined ? moment(val?.approvedAt).fromNow() : '-'}
                      </td>
                      <td>
                        <span
                          className={`badge badge-light-${bgColor?.[val?.status]}`}
                          style={{textTransform: 'capitalize'}}
                        >
                          {val?.status}{' '}
                        </span>{' '}
                      </td>

                      <td>
                        {!isShareNumber(val) ? (
                          <div className='d-flex justify-content-center flex-shrink-0'>
                            {AuthenticateUser('create-custom-number') && val?.status == 'active' && (
                              <>
                                {' '}
                                {val?.isDefault == false ? (
                                  <label
                                    onClick={() =>
                                      dispatch(
                                        setDefaultCustomNumber({
                                          customNumberId: val?._id,
                                          isDefault: true,
                                        })
                                      )
                                    }
                                    className='btn btn-sm btn-light-primary border-light-primary border-dashed me-5'
                                  >
                                    Set Default
                                  </label>
                                ) : (
                                  <label
                                    onClick={() =>
                                      dispatch(
                                        setDefaultCustomNumber({
                                          customNumberId: val?._id,
                                          isDefault: false,
                                        })
                                      )
                                    }
                                    className='btn btn-sm btn-light-primary border-light-primary border-dashed me-5'
                                  >
                                    {' '}
                                    Default
                                  </label>
                                )}
                              </>
                            )}
                            {AuthenticateUser('create-custom-number') && (
                              <span
                                onClick={() => handleDelete(val?._id)}
                                className='btn btn-icon btn-light-primary border-light-primary btn-sm delete_action'
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen027.svg'
                                  className='svg-icon-3'
                                />
                              </span>
                            )}
                          </div>
                        ) : (
                          <div className='d-flex justify-content-center flex-shrink-0'>--</div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
        ) : (
          <InsertNewData
            message={{
              title: 'No Custom Number verified (yet!)',
              subtitle: `It looks like you haven't verified any numbers yet - this will allow you to easily use your own number to send messages`,
            }}
            roleCheck='create-custom-number'
            buttonName={{
              name: 'Verify new number',
              link: '/new-message',
              popup: true,
              buttonFun: () => setShowModalNew(true),
            }}
          />
        )}
        {/* begin::Body */}
      </div>
    </>
  )
}

export default CustomNumberList
